import { CloseCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { AccessSource } from '@prisma/client';
import { useQueryClient } from '@tanstack/react-query';
import { Button, Descriptions, Modal, Space } from 'antd';

import { SubscriptionAccessArchiveKeys } from '../data/subscription-access-archives';

import { SubscriptionAccessArchivePanel } from './subscription-access-archive-panel';

export type SubscriptionAccessArchiveModalProps = {
  subscriptionAccess?: {
    id: number;
    subscriberUserName: string;
    subscriptionAccessName: string;
    subscriptionAccessSource: AccessSource;
  };
  onClose: () => void;
};

export const SubscriptionAccessArchiveModal = ({
  subscriptionAccess,
  onClose,
}: SubscriptionAccessArchiveModalProps) => {
  const queryClient = useQueryClient();

  const reload = async () => {
    await queryClient.invalidateQueries({ queryKey: SubscriptionAccessArchiveKeys.all }); // force repull of cases
  };

  if (!subscriptionAccess) return undefined;

  return (
    <Modal
      title="History"
      centered
      width={1100}
      styles={{
        body: {
          paddingTop: 15,
          height: 500,
          overflow: 'auto',
        },
      }}
      open={!!subscriptionAccess}
      onCancel={onClose}
      footer={[
        <Button key="refresh" onClick={reload} icon={<ReloadOutlined />}>
          Refresh
        </Button>,
        <Button key="close" onClick={onClose} icon={<CloseCircleOutlined />} type="primary">
          Close
        </Button>,
      ]}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Descriptions bordered size="small" layout="horizontal" column={2}>
          <Descriptions.Item label="Subscriber">{subscriptionAccess?.subscriberUserName}</Descriptions.Item>
          <Descriptions.Item> &nbsp; </Descriptions.Item>
          <Descriptions.Item label="Access">{subscriptionAccess?.subscriptionAccessName}</Descriptions.Item>
          <Descriptions.Item label="Access Source">{subscriptionAccess?.subscriptionAccessSource}</Descriptions.Item>
        </Descriptions>
        {subscriptionAccess ? (
          <SubscriptionAccessArchivePanel subscriptionAccessId={subscriptionAccess.id} />
        ) : undefined}
      </Space>
    </Modal>
  );
};
